import styled, { css } from 'styled-components'
export {
  BackButton,
  BackIcon,
} from 'modules/shares/ComponentsWebView/components/Sidebar/MobileGroupsDropdown.styles'
export {
  SelectDropdownModalFooter,
  SelectDropdownCancelButton,
} from '@sketch/components'

export const MobileNavigationHeader = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    font-weight: ${theme.fontWeights.semibold};
    font-size: ${theme.fontSizes.B};
    text-transform: uppercase;
    padding: 8px 16px 12px;
  `
)
